<template>
	<div class="header">
		<div class="navbar">
			<div class="row">
				<router-link to="/" class="navbar-logo">
						<img src="../assets/logo.svg" alt="*" />
						<div class="text">
							<h1>「内向型」<span>のための成功請負結社</span></h1>
							<h2>INTROVERT<span>S</span></h2>
						</div><!-- end .text -->
					
				</router-link><!-- end .navbar-logo -->
				<div class="navbar-menu">
					<nav v-bind:class='{active:mobileMenuActive}'>
						<ul>
							<li>
								<router-link to="/" v-on:click.native="mobileMenuNonActive">
							トップ</router-link>
							</li>
							<li>
								<router-link to="/questions/" v-on:click.native="mobileMenuNonActive">
									内向性診断テスト
								</router-link>
							</li>
							<li>
								<a href="https://introverts.jp/articles/">
									特集記事
								</a>
							</li>
							<li>
								<a href="https://introverts.jp/company/">
									運営者情報
								</a>
							</li>
							<li class="contact">
								<a href="https://introverts.jp/contact/">
									<div><img src="../assets/icon-mail.svg" alt="*" /></div>
									<div>お問い合わせ</div>
								</a>
							</li>
						</ul>
					</nav>
					<div class="navbar-icon" v-bind:class='{active:mobileMenuActive}' v-on:click="mobileMenuActive=!mobileMenuActive">
						<span></span>
					</div><!-- end .navbar-icon -->
				</div><!-- end .navavr-menu -->
			</div><!-- end .row -->
		</div><!-- end .navbar -->
	</div><!-- end .header -->
</template>

<script>
export default {
	name: 'Header',
	data: function () {
		return {
			mobileMenuActive:false,   
		}
	},
	methods: {
		mobileMenuNonActive:function(){
			this.mobileMenuActive=!this.mobileMenuActive;
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

/*===================================================================
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □

〇 .NAVBAR pc 〇

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □      
====================================================================*/
.header{
	box-shadow: 0px 4px 14px 3px #aaa;
}
.navbar {
	padding: 10px 3%;
	
	.row {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 0;
	}
	&-logo {
		width: 300px;
		display: flex;
		align-items: center;
		text-align: left;
		text-decoration: none;
		img{
			width:80px;
			height: auto;
		}
		.text{
			padding:0 0 0 10px;
			color:#117d7f;
			h1{
				font-size:12px;
				margin:0;
				line-height: 1.3;
				font-family: source-han-sans-japanese, sans-serif;
				font-weight: 700;
				font-style: normal;
				letter-spacing: 1px;
			}
			h2{
				font-size:37px;
				margin:0;
				line-height: 1.3;
				font-weight: bold;

			}
			h1 span,
			h2 span{
				color:#2c1a1a;
			}
		}
	}
	&-icon {
		display: flex;
		justify-content: flex-end;
		height: 40px;
		align-items: center;
		span {
			width: 36px;
			height: 3px;
			background-color: #000;
			display: block;
			position: relative;
			transition: 0.3s;
			z-index: 2000;
			&:after {
				content: "";
				width: 36px;
				height: 3px;
				position: absolute;
				top: 9px;
				left:0;
				background-color: #000;
				transition: 0.3s;
			}
			&:before {
				content: "";
				width: 36px;
				height: 3px;
				position: absolute;
				bottom: 9px;
				background-color: #000;
				transition: 0.3s;
				left:0;
			}
		}/********* end span *********/
		&.active {
			span {
				background-color: transparent;
				&:before {
					transform: rotate(45deg);
					bottom: 0;
					background-color: #fff;
				}
				&:after {
					transform: rotate(-45deg);
					background-color: #fff;
					top: 0;
				}
			}
		}/********* end &.active *********/
	}/********* end &-icon *********/
	&-menu {
		flex-basis: 65%;
		nav {
			ul {
				margin: 0;
				padding: 0;
				display: flex;
				list-style: none;
				justify-content: space-between;
				overflow: auto;
				-webkit-overflow-scrolling: touch;
				font-family: source-han-sans-japanese, sans-serif;
				font-weight: 700;
				font-style: normal;
				li {
					margin: 0;
				
					a {
						display: block;
						padding: 20px 0px 15px;
						color: #2c1a1a;
						transition: 0.3s;
						text-decoration: none;
						font-size:18px;
						font-weight: bold;
						line-height: 2.2;
						letter-spacing: 1px;

					}
					&:hover {
						a {
							
							transform: translateY(-3px);
						}
					} /********* end :hover *********/
					&.contact{
						background:#117d7f;
						text-align: center;
						border-radius:40px;
						margin:0 0 0 0px;

						
						a{
							display: flex;
							align-items: center;
							justify-content: center;
							color:#fff;
							padding: 15px 60px;
							img{
								width:30px;
								height: auto;
								margin:0 10px 0 0;
								position: relative;
								top:5px;
							}
						}
					}
					
					
				} /********* end li *********/
			} /********* end ul *********/
		} /********* end nav *********/
	} /********* end &-menu *********/
} /********* end .navbar *********/


/**********************************************************************************
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □  

◆	Stylesheet: 992px～1280pxまでのモニタで適用	◆

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
start----------------------------------------------------------------------------*/

@media screen and (min-width: 992px) and (max-width: 1280px) {
	.header{
		box-shadow: 0px 4px 14px 3px #aaa;
	}
	.navbar {
		padding: 10px 2.5%;
		
		.row {
			width: 100%;

		}
		&-logo {
			//width: 230px;
			img{
				width:60px;
				height: auto;
			}
			.text{
				padding:0 0 0 10px;
				h1{
					font-size:11px;
					letter-spacing: 1px;
				}
				h2{
					font-size:30px;
					margin:0;
					line-height: 1.3;
					font-weight: bold;

				}
			}
		}
		&-icon {
			display: flex;
			justify-content: flex-end;
			height: 40px;
			align-items: center;
			span {
				width: 36px;
				height: 3px;
				display: block;
				position: relative;
				transition: 0.3s;
				z-index: 2000;
				&:after {
					content: "";
					width: 36px;
					height: 3px;
					position: absolute;
					top: 9px;
					left:0;
					background-color: #000;
					transition: 0.3s;
				}
				&:before {
					content: "";
					width: 36px;
					height: 3px;
					position: absolute;
					bottom: 9px;
					background-color: #000;
					transition: 0.3s;
					left:0;
				}
			}/********* end span *********/
			&.active {
				span {
					background-color: transparent;
					&:before {
						transform: rotate(45deg);
						bottom: 0;
						background-color: #fff;
					}
					&:after {
						transform: rotate(-45deg);
						background-color: #fff;
						top: 0;
					}
				}
			}/********* end &.active *********/
		}/********* end &-icon *********/
		&-menu {
			flex-basis: 65%;
			nav {
				ul {
					margin: 0;
					padding: 0;
					display: flex;
					list-style: none;

					overflow: auto;
					-webkit-overflow-scrolling: touch;
					font-family: source-han-sans-japanese, sans-serif;
					font-weight: 700;
					font-style: normal;
					li {
						margin: 0;
					
						a {
							display: block;
							padding: 20px 0px 15px;
							color: #2c1a1a;
							transition: 0.3s;
							text-decoration: none;
							font-size:16px;
							font-weight: bold;
							line-height: 2.2;
							letter-spacing: 1px;

						}
						&:hover {
							a {
								
								transform: translateY(-3px);
							}
						} /********* end :hover *********/
						&.contact{
							background:#117d7f;
							text-align: center;
							border-radius:40px;
							margin:0 0 0 0px;

							
							a{
								display: flex;
								align-items: center;
								justify-content: center;
								color:#fff;
								padding: 15px 30px;
								img{
									width:28px;
									height: auto;
									margin:0 8px 0 0;
									position: relative;
									top:5px;
								}
							}
						}
						
						
					} /********* end li *********/
				} /********* end ul *********/
			} /********* end nav *********/
		} /********* end &-menu *********/
	} /********* end .navbar *********/
} /* 992px～1280px responsive-closed */



/*===================================================================
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □

〇 .NABVAR Responsive 〇

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □      
====================================================================*/
@media screen and (min-width: 992px) {
	.navbar {
		&-icon {
			display: none;
		}
	}/********* end .navbar *********/
}/********* end @media screen and (min-width: 992px) *********/

@media screen and (max-width: 991px) {
	.navbar {
		.row {
			justify-content: space-between;
		}
		&-logo {
			//width: 250px;
			img{
				width: 60px;
    
			}
			.text{
				h1{
					font-size:11px;
				}
				h2{
					font-size:30px;
				}
			}
		}
		&-menu {
			flex-basis: auto;
			nav {
				visibility: hidden;
				position: fixed;
				padding: 0px 0 0px 0;
				ul {
					margin:0;
					padding: 30px 0 30px 0;
					li {
						transform: translateX(-10px);
						opacity: 0;
						&.contact{
							margin:20px auto 0;
						}
					}
				}
				&.active {
					visibility: visible;
					position: fixed;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background-color: #292929;
					z-index:1000;
					ul {
						flex-direction: column;
						justify-content: flex-start;
						align-items: center;
						height: 100%;
						li {
							transform: translateX(0);
							opacity: 1;
							transition: 0.9s;
							@for $i from 1 through 9 {
								&:nth-child(#{$i}) {
									transition-delay: #{$i * 0.15}s;
								}
							}
							a {
								color: #fff;
								font-size: 22px;
								padding: 15px 0px 10px;
							}
							&.contact{
								a{
									padding: 15px 40px 15px;
								}
							}
						} /********* end li *********/
					} /********* end &-menu ul *********/ 
				} /********* end &.active *********/ 
			} /********* end nav *********/
		} /********* end &-menu *********/
	} /********* end .navbar *********/
} /********* end .@media screen and (max-width: 991px) *********/



/**********************************************************************************
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □   

◆	Stylesheet: さらに刻んで320pxまでのモニタで適用	◆

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
start----------------------------------------------------------------------------*/

@media screen and (max-width: 320px) {
	.navbar {
		
		&-logo {
			//width: 200px;

			img{
				width:40px;
			}
			.text{
				h1{
					font-size:11px;
				}
				h2{
					font-size:28px;
				}
				h1 span,
				h2 span{
					color:#2c1a1a;
				}
			}
		}
	}
} /* 320px responsive-closed */

/*end ----------------------------------------------------------------------------
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
**********************************************************************************/

</style>
